/**
 * Reading the query string, without the empty key.
 *
 * `common/utils.getQueryStringParameters` splits on `&` unconditionally, so an
 * empty search gives it `['']` and it stores `{ '': 'undefined' }` — the string,
 * because `decodeURIComponent(undefined)` returns `"undefined"`. Harmless while
 * you only read named filters, which is all the old admin does; but every page in
 * this tree builds its next URL by spreading the whole object, so that ghost key
 * came back out as `?=undefined` on the first click of a sort or a pager.
 *
 * Wrapped rather than fixed at the source: `getQueryStringParameters` is called
 * from a few dozen old pages, and this tree does not change files the old admin
 * reads.
 */
import { getQueryStringParameters } from '../common/utils';

export function readQuery(search) {
  const raw = getQueryStringParameters(search || '');
  const clean = {};

  Object.entries(raw).forEach(([key, value]) => {
    if (!key) return;
    if (value === undefined || value === 'undefined') return;
    clean[key] = value;
  });

  return clean;
}
